import { useStatusModalContext } from '../contexts/StatusModalContext';
import StatusModal from '../components/modal/StatusModal';

const StatusModalContainer = () => {
    const { state, closeStateModal } = useStatusModalContext();

    return (
        <StatusModal
            isOpen={state.isStatusModalOpen}
            closeModal={closeStateModal}
            message={state.message}
            title={state.title}
            isError={state.isError}
            isSuccess={state.isSuccess}
            refresh={state.refresh}
        />
    );
};

export default StatusModalContainer;
